import { CookieKeys, setCookie } from "@lib/cookies";
import { setAccessToken } from "@store/visitWidgetApi";
import { initializeUser } from "../helpers/initializeUser";
import { AppDispatch } from "@store/store";
import { setUserAction, signInAction } from "@store/sessionReducer";

export interface AuthTokenSuccessActionParams {
  authToken: string;
}

const authTokenSuccessAction =
  ({ authToken }: AuthTokenSuccessActionParams) =>
  async (dispatch: AppDispatch) => {
    setCookie(CookieKeys.authToken, authToken);
    setAccessToken(authToken);
    const { user } = await initializeUser(authToken, dispatch);
    if (!user) {
      return;
    }

    dispatch(setUserAction({ user: user }));
    dispatch(signInAction({ authToken }));
  };

export { authTokenSuccessAction };
